import useSWR from 'swr';
import apiClient from '../helpers/ApiClient';
import OfflineStorage from '../helpers/OfflineStorage';

const fetcher = async (url) => {
  const isOnline = OfflineStorage.isClientOnline();
  if (!isOnline && url.includes('/daybook')) {
    const cached = OfflineStorage.getCachedDayBook();
    if (cached) return cached;
  }
  try {
    const res = await apiClient.get(url);
    if (url.includes('/daybook') && res.data) {
      OfflineStorage.cacheDayBook(res.data);
    }
    return res.data;
  } catch (err) {
    if (url.includes('/daybook')) {
      const cached = OfflineStorage.getCachedDayBook();
      if (cached) return cached;
    }
    throw err;
  }
};

export function useActiveShift() {
  const { data, error, mutate } = useSWR('/reports/day-book/current-shift', fetcher);
  const activeObj = data?.hasActiveShift ? (data?.currentShift || data?.shift) : null;
  return {
    shift: activeObj,
    summary: activeObj?.current_stats || data?.currentShift?.current_stats || data?.shift?.current_stats || data?.summary || null,
    hasActiveShift: Boolean(data?.hasActiveShift && activeObj),
    lastClosedShift: data?.lastClosedShift,
    lastClosingBalance: data?.lastClosingBalance,
    isLoading: !error && !data,
    isError: error,
    mutate
  };
}

export function useShiftsList() {
  const { data, error, mutate } = useSWR('/reports/day-book/shifts?limit=50', fetcher);
  return {
    shifts: data?.shifts || [],
    isLoading: !error && !data,
    isError: error,
    mutate
  };
}

export function useShiftDetails(shiftId) {
  const { data, error, mutate } = useSWR(shiftId ? `/reports/day-book/shifts/${shiftId}` : null, fetcher);
  return {
    details: data,
    isLoading: !error && !data,
    isError: error,
    mutate
  };
}

export async function openShift(openingCash, openingDenominations, note = '') {
  const res = await apiClient.post('/reports/day-book/start-shift', {
    startingFloat: Number(openingCash) || 0,
    openingBalance: Number(openingCash) || 0,
    note: note,
    startDenominations: openingDenominations,
    denominations: openingDenominations
  });
  return res.data;
}

export async function closeShift(shiftId, closingCash, closingDenominations, expectedCash, cashDifference, note = '') {
  const res = await apiClient.post('/reports/day-book/end-shift', {
    shiftId: shiftId,
    actualCashInHand: Number(closingCash) || 0,
    actualCash: Number(closingCash) || 0,
    closingBalance: Number(closingCash) || 0,
    expectedCash: Number(expectedCash) || 0,
    cashDifference: Number(cashDifference) || 0,
    note: note,
    denominations: closingDenominations
  });
  return res.data;
}

export function useCurrentRegister() {
  const { data, error, mutate } = useSWR('/registers/current', fetcher);
  return {
    data,
    isLoading: !error && !data,
    isError: error,
    mutate
  };
}

export function useRegisterByDate(date) {
  const { data, error, mutate } = useSWR(date ? `/registers/by-date?date=${date}` : null, fetcher);
  return {
    data,
    isLoading: !error && !data,
    isError: error,
    mutate
  };
}

export function useDayBook(from, to) {
  const { data, error, mutate } = useSWR(`/daybook?from=${from}&to=${to}`, fetcher);
  return {
    data,
    isLoading: !error && !data,
    isError: error,
    mutate
  };
}

export async function reassignInvoiceDate(invoiceIds, targetDate, targetTime = null) {
  const ids = Array.isArray(invoiceIds) ? invoiceIds : [invoiceIds];
  const res = await apiClient.post('/registers/reassign-invoice-date', {
    invoice_ids: ids,
    target_date: targetDate,
    target_time: targetTime
  });
  return res.data;
}
